import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import axios from 'axios'

// Configure axios base URL (relative so it works in Docker/nginx and dev)
axios.defaults.baseURL = '/api'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
